// extracted by mini-css-extract-plugin
export default {"technicalInfoLabel":"src-utils-styles_technicalInfoLabel","technicalInfo":"src-utils-styles_technicalInfo"};